module.exports = __webpack_public_path__ + "static/media/5 7 tattoo legs emboar tentacruel elemental duel cinematic.1280x1538.30b60bab.webp";